import React from 'react'
import { DIFFERENCE_COPY, STATUS_COPY } from './review-copy'
import type { UpgradeReviewRow } from './review-types'

const resultClass = (status: UpgradeReviewRow['status']) => {
    if (status === 'ok') return 'bg-[rgb(35_133_81_/_10%)] text-[#1C6E42]'
    if (status === 'differences' || status === 'unparseable')
        return 'bg-[rgb(200_118_25_/_10%)] text-[#935610]'
    return 'bg-[rgb(143_153_168_/_15%)] text-[#5F6B7C]'
}

const finding = (row: UpgradeReviewRow) => {
    if (row.status === 'pending') return 'Still checking this Recipe.'
    if (row.status === 'unparseable') return "Fix this Recipe's trigger before upgrading it."
    if (row.status === 'upgraded') return 'Upgraded to a Segment.'
    const classes = row.diff_summary.classes || []
    if (!classes.length) return 'No differences found.'
    return classes
        .map(({ count, class: difference }) => `${count} ${DIFFERENCE_COPY[difference](count)}`)
        .join(' ')
}

export const UpgradeReviewTable = ({
    rows,
    selectedId,
    onSelect,
}: {
    rows: UpgradeReviewRow[]
    selectedId?: string
    onSelect: (row: UpgradeReviewRow) => void
}) => (
    <div className="overflow-hidden rounded border border-[#E5E7EB] bg-white">
        <div className="grid h-11 grid-cols-[minmax(180px,260px)_150px_minmax(220px,1fr)_90px] items-center border-b border-[#E5E7EB] bg-[#FBFBFB] px-[18px] text-[11px] font-bold tracking-[0.04em] text-[#91969B]">
            <span>RECIPE</span>
            <span>RESULT</span>
            <span>DETAILS</span>
            <span />
        </div>
        {rows.map((row) => {
            const selected = row.recipe_id === selectedId
            return (
                <button
                    type="button"
                    key={row.recipe_id}
                    onClick={() => onSelect(row)}
                    className={`grid h-[60px] w-full grid-cols-[minmax(180px,260px)_150px_minmax(220px,1fr)_90px] items-center border-b border-[#E5E7EB] px-[18px] text-left last:border-b-0 ${selected ? 'bg-[#EAEDF1]' : 'bg-white odd:bg-[#FBFBFB]'}`}
                >
                    <span className="truncate text-sm text-[#1C2127]">{row.name}</span>
                    <span>
                        <span
                            className={`inline-block rounded-sm px-1.5 py-0.5 text-xs leading-4 ${resultClass(row.status)}`}
                        >
                            {STATUS_COPY[row.status]}
                        </span>
                    </span>
                    <span className="truncate text-[13px] leading-5 text-[#5F6B7C]">
                        {finding(row)}
                    </span>
                    <span className="text-[13px] text-[#91969B]">{selected ? 'Selected' : ''}</span>
                </button>
            )
        })}
    </div>
)
